module.exports = __webpack_public_path__ + "media/images/icons/filled/euro-circle-c266e6479074e7c95ff4c1e637bd33a1.svg";